import { motion } from "framer-motion";
import { PILOT_PROCESS_STEPS } from "@/data/content";

export const PilotProcess = () => (
  <section id="pilot-process" data-testid="pilot-process-section" className="bg-baseLight px-6 pt-[30px] pb-[10px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="max-w-2xl lg:mx-auto lg:max-w-none lg:text-center">
        <h2
          data-testid="pilot-process-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:whitespace-nowrap lg:text-[36px]"
        >
          From inquiry to project evaluation
        </h2>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        data-testid="pilot-process-sequence"
        className="relative mt-12 lg:mt-14"
      >
        <div className="absolute left-0 right-0 top-[44px] hidden h-px bg-borderLight lg:block" aria-hidden="true" />
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          {PILOT_PROCESS_STEPS.map((step, i) => (
            <div key={step.n} data-testid={`pilot-process-step-${step.n}`} className="relative">
              <span className="relative z-10 block font-heading text-5xl font-bold text-ink/10 lg:text-6xl">
                {step.n}
              </span>
              <h3 className="mt-2 font-heading text-lg font-semibold uppercase tracking-wide text-ink">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-inkSoft">
                {step.title === "Submit Your Interest" ? (
                  <>
                    Share basic information about your operation
                    <br className="sm:hidden" /> and energy requirements.
                  </>
                ) : (
                  step.body
                )}
              </p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
